import React, { useEffect, useRef, useState } from "react";
import "./index.css";
import userlogo from "../images/user.png";
import {
  deleteDocument,
  getAllApprovedleaves,
  getAllEmployeesCleaningShifts,
  getAllEmployeeslotfordate,
  getAllEmployeeTasks,
  getallexpressslotsdata,
  getAllSlotsForChecking,
  getAllSlotsWhere,
  getAllTripHistoryForChecking,
  getAllVehiclesWhere,
  getuserinformation,
  saveitem,
  saveitemwithid,
  updateItem,
  updateNestedArrayItem,
  updateNestedItem,
} from "../../utils/firebasefunctions";
import emailjs from "emailjs-com";

import { useLocation, useNavigate } from "react-router-dom";
import { IoIosCloseCircle } from "react-icons/io";
import { useStateValue } from "../context/StateProvider";
import { actionType } from "../context/reducer";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ToastContainer, toast } from "react-toastify";
import { FaUser } from "react-icons/fa";
import { CiCircleMinus, CiCirclePlus } from "react-icons/ci";
import { FaCircleMinus } from "react-icons/fa6";
import moment from "moment";
import TimePicker from "react-time-picker";
import "react-time-picker/dist/TimePicker.css";
import "react-clock/dist/Clock.css";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { RotatingLines } from "react-loader-spinner";
import { arrayUnion, count, doc, getDoc } from "firebase/firestore";
import { IoIosRadioButtonOn, IoIosRadioButtonOff } from "react-icons/io";
import { IoRadioButtonOff, IoRadioButtonOn } from "react-icons/io5";
import { FaDollarSign } from "react-icons/fa";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";

import { FaPlus } from "react-icons/fa6";
import { MdDelete } from "react-icons/md";
import { RiGalleryView2 } from "react-icons/ri";
import { RiGalleryView } from "react-icons/ri";
import EmployeePopup from "../components/EmployeePopup";
import DesignationPopUp from "../components/DesignationPopUp";
import Vehicledropdown from "../components/Vehicledropdown";
import { firestored } from "../../firebase.config";
import { DndContext, closestCenter } from "@dnd-kit/core";
import {
  SortableContext,
  verticalListSortingStrategy,
  useSortable,
  arrayMove,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import ProjectPopUp from "../components/ProjectPopUp";
import {
  fromAddress,
  geocode,
  setKey,
  setLanguage,
  setRegion,
} from "react-geocode";
import { FaArrowRight } from "react-icons/fa";

function CreateExpressDelivery() {
  const [{ user, employees, clients }, dispatch] = useStateValue();
  const location = useLocation();

  const [projectid, setprojectid] = useState(
    location.state?.projectid ? location.state.projectid : user?.id,
  );
  const [openshift, setopenshift] = useState(location.state?.openshift);

  const [shiftcount, setshiftcount] = useState(1);
  const [cleanershiftedit, setcleanershiftedit] = useState(
    location.state?.cleanershiftedit ? location.state.cleanershiftedit : false,
  );
  const [cleaningshiftdata, setcleaningshiftdata] = useState(
    location.state?.cleaningshiftdata ? location.state.cleaningshiftdata : "",
  );

  const [vehicles, setvehicles] = useState([]);

  const [projectdata, setprojectdata] = useState("");
  const [selectedemployee, setselectedemployee] = useState([]);
  const [Location, setLocation] = useState("");
  const [startdate, setstartdate] = useState(new Date());
  const [lunchstartdate, setlunchstartdate] = useState(new Date());
  const [lunchenddate, setlunchenddate] = useState(new Date());
  const [startingdate, setstartingdate] = useState(new Date());
  const [starttime, setstarttime] = useState("10:00");
  const [deliverydate, setdeliverydate] = useState(new Date());
  const [deliverytime, setdeliverytime] = useState("10:00");
  const [endingdate, setendingdate] = useState(new Date());
  const [endtime, setendtime] = useState("19:00");
  const [lunchstarttime, setlunchstarttime] = useState("13:00");
  const [lunchendtime, setlunchendtime] = useState("14:00");
  const [enddate, setenddate] = useState(new Date());
  const [shifttype, setshifttype] = useState("Driver");
  const [designation, setdesignation] = useState("");
  const [designationoptions, setdesignationoptions] = useState([]);
  const [employeepopup, setemployeepopup] = useState(false);
  const [designationpopup, setdesignationpopup] = useState(false);
  const [selectedvehicle, setselectedvehicle] = useState("");
  const [vehiclepopup, setvehiclepopup] = useState(false);
  const [lunchenabled, setlunchenabled] = useState(false);
  const [loading, setloading] = useState(false);
  const [slots, setslots] = useState([]);
  const [tasks, settasks] = useState([]);
  const [tasksavailabledays, settasksavailabledays] = useState([]);
  const [projectselectionpopup, setprojectselectionpopup] = useState(false);
  const [project, setproject] = useState("");
  const [selectedprojects, setselectedprojects] = useState([]);
  const [dropoffdestinations, setdropoffdestinations] = useState([]);
  const [jobs, setjobs] = useState([]);
  const [value, onChange] = useState(new Date());
  const [createslot, setcreateslot] = useState(true);
  const [allemployeeleaves, setallemployeeleaves] = useState([]);
  const [slotdeletionloader, setslotdeletionloader] = useState(false);
  const [slotdeletionindex, setslotdeletionindex] = useState(0);
  const [cleanertasksstorage, setcleanertasksstorage] = useState([]);
  const [cleanertasks, setcleanertasks] = useState([
    {
      day: "Monday",
      numberoftasks: 1,
      tasksdata: [
        {
          id: 0,
          tasks: "",
          completed: false,
        },
      ],
    },
    {
      day: "Tuesday",
      numberoftasks: 1,
      tasksdata: [
        {
          id: 0,
          tasks: "",
          completed: false,
        },
      ],
    },
    {
      day: "Wednesday",
      numberoftasks: 1,
      tasksdata: [
        {
          id: 0,
          tasks: "",
          completed: false,
        },
      ],
    },
    {
      day: "Thursday",
      numberoftasks: 1,
      tasksdata: [
        {
          id: 0,
          tasks: "",
          completed: false,
        },
      ],
    },
    {
      day: "Friday",
      numberoftasks: 1,
      tasksdata: [
        {
          id: 0,
          tasks: "",
          completed: false,
        },
      ],
    },
    {
      day: "Saturday",
      numberoftasks: 1,
      tasksdata: [
        {
          id: 0,
          tasks: "",
          completed: false,
        },
      ],
    },
    {
      day: "Sunday",
      numberoftasks: 1,
      tasksdata: [
        {
          id: 0,
          tasks: "",
          completed: false,
        },
      ],
    },
    {
      day: "Monthly",
      numberoftasks: 1,
      tasksdata: [
        {
          id: 0,
          tasks: "",
          completed: false,
        },
      ],
    },
    {
      day: "Quarterly",
      numberoftasks: 1,
      tasksdata: [
        {
          id: 0,
          tasks: "",
          completed: false,
        },
      ],
    },
    {
      day: "Yearly",
      numberoftasks: 1,
      tasksdata: [
        {
          id: 0,
          tasks: "",
          completed: false,
        },
      ],
    },
  ]);

  const apikey = "AIzaSyDHDrEb9r2EEgcMLoWKp6aGVA9WIq0kIho";

  const navigate = useNavigate();

  //     const getallprojectslotsforselecteddate = async () => {
  //     await getAllEmployeeslotfordate(
  //       "slots",
  //       "projectid",
  //       "==",
  //       projectid,
  //       "sheduleddate",
  //       "==",
  //       moment(value).format("YYYY-MM-DD"),
  //     )
  //       .then(async (response) => {
  //         let responsedata = [...response];
  //         for (const index in responsedata) {
  //           responsedata[index]["employeedata"] = employees
  //             .filter(function (data) {
  //               return data.id == responsedata[index].employeeid;
  //             })
  //             .map(function (data) {
  //               return data;
  //             });
  //           responsedata[index]["name"] = employees
  //             .filter(function (data) {
  //               return data.id == responsedata[index].employeeid;
  //             })
  //             .map(function (data) {
  //               return data.firstname + " " + data.lastname;
  //             });
  //           responsedata[index]["designation"] = employees
  //             .filter(function (data) {
  //               return data.id == responsedata[index].employeeid;
  //             })
  //             .map(function (data) {
  //               return data.projectdesignation;
  //             });
  //           responsedata[index]["profilepicture"] = employees
  //             .filter(function (data) {
  //               return data.id == responsedata[index].employeeid;
  //             })
  //             .map(function (data) {
  //               return data.profilepicture;
  //             });
  //         }

  //         setslots(responsedata);
  //       })
  //       .catch((err) => {
  //         alert(err);
  //       });
  //   };

  async function listofallemployeeleaves() {
    let filteredemployees = employees.filter(function (data) {
      return (
        (data.usertype == "Employee" &&
          data?.projectassigned?.find(
            (dataset) => dataset.project == projectid,
          ) != undefined &&
          cleaningshiftdata?.employees?.find(
            (dataset) => dataset == data?.id,
          ) == undefined) ||
        (data.usertype == "Supervisor" &&
          data.employeerole == true &&
          data?.projectassigned?.find(
            (dataset) => dataset.project == projectid,
          ) != undefined &&
          cleaningshiftdata?.employees?.find(
            (dataset) => dataset == data?.id,
          ) == undefined)
      );
    });

    filteredemployees = filteredemployees.map((emp) => emp.id);

    function chunkArray(array, chunkSize = 30) {
      const chunks = [];
      for (let i = 0; i < array.length; i += chunkSize) {
        chunks.push(array.slice(i, i + chunkSize));
      }
      return chunks;
    }

    const chunkedArrays = chunkArray(filteredemployees, 30);

    let leavesdataset = [];

    chunkedArrays.forEach(async (employeesets, index) => {
      await getAllApprovedleaves("ApprovedLeaves", "employeeid", employeesets)
        .then(async (responseleaves) => {
          console.log("all employees leaves " + JSON.stringify(responseleaves));

          const flattened = responseleaves.flatMap((emp) =>
            emp.leaves?.map((date) => ({
              date,
              employeeid: emp.employeeid,
            })),
          );
          leavesdataset = [...leavesdataset, ...flattened];

          if (chunkedArrays.length - 1 == index) {
            const sorted = leavesdataset.sort(
              (a, b) => new Date(a.date) - new Date(b.date),
            );

            const filteredbydate = leavesdataset.filter((item) => {
              const today = new Date();
              today.setHours(0, 0, 0, 0); // Set time to start of day

              const itemDate = new Date(item.date);
              itemDate.setHours(0, 0, 0, 0); // Normalize time

              return itemDate >= today;
            });
            setallemployeeleaves(filteredbydate);
            console.log("all employees leaves " + JSON.stringify(sorted));
          }
        })
        .catch((err) => {
          alert(err);
        });
    });

    console.log("all employees " + JSON.stringify(filteredemployees));
  }

  function monthsBetween(from, to) {
    return (
      (to.getFullYear() - from.getFullYear()) * 12 +
      (to.getMonth() - from.getMonth())
    );
  }

  function matchesFrequency(currentDate, projectCreatedAt, type) {
    const projectDate = new Date(projectCreatedAt);

    // 🔒 Exact day-of-month match ONLY
    if (currentDate.getDate() !== projectDate.getDate()) {
      return false;
    }

    const monthsDiff = monthsBetween(projectDate, currentDate);

    // Cannot occur before project creation
    if (monthsDiff < 0) return false;

    switch (type) {
      case "monthly":
        // Every month on the same day
        return monthsDiff >= 1;

      case "quarterly":
        // Every 3 months on same day
        return monthsDiff >= 3 && monthsDiff % 3 === 0;

      case "yearly":
        // Every 12 months on same day
        return monthsDiff >= 12 && monthsDiff % 12 === 0;

      default:
        return false;
    }
  }
  function getDaysBetweenDates(startDate, endDate) {
    let statingdate = startDate;
    statingdate.setHours(0, 0, 0, 0);

    let endingdate = endDate;
    endingdate.setHours(23, 59, 59, 59);

    const daysOfWeek = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    const result = new Set();

    let currentDate = new Date(statingdate);
    let projectcreationdate = projectdata?.creationdate;
    while (currentDate <= endingdate) {
      result.add(daysOfWeek[currentDate.getDay()]);

      // ✅ Monthly / Quarterly / Yearly checks PER DAY
      if (matchesFrequency(currentDate, projectcreationdate, "monthly")) {
        result.add("Monthly");
      }

      if (matchesFrequency(currentDate, projectcreationdate, "quarterly")) {
        result.add("Quarterly");
      }

      if (matchesFrequency(currentDate, projectcreationdate, "yearly")) {
        result.add("Yearly");
      }
      currentDate.setDate(currentDate.getDate() + 1); // Move to the next day
    }

    settasksavailabledays(Array.from(result));
  }

  const handledesignationChange = (event, index, innerindex) => {
    let data = [...selectedprojects];
    data[index].tasks[innerindex].notetorider = event.target.value;
    setselectedprojects(data);
  };

  const handleendingtaskdateChange = (event, index) => {
    let data = [...tasks];
    data[index].endingdate = event;
    settasks(data);
  };

  const handleendingtasktimeChange = (event, index) => {
    let data = [...tasks];
    data[index].endingtime = event;
    settasks(data);
  };

  const getallprojectslotsforselecteddate = async () => {
    await getAllEmployeeslotfordate(
      "slots",
      "projectid",
      "==",
      projectid,
      "sheduleddate",
      "==",
      moment(value).format("YYYY-MM-DD"),
    )
      .then(async (response) => {
        let responsedata = [...response];
        for (const index in responsedata) {
          responsedata[index]["employeedata"] = employees
            .filter(function (data) {
              return data.id == responsedata[index].employeeid;
            })
            .map(function (data) {
              return data;
            });
          responsedata[index]["name"] = employees
            .filter(function (data) {
              return data.id == responsedata[index].employeeid;
            })
            .map(function (data) {
              return data.firstname + " " + data.lastname;
            });
          responsedata[index]["designation"] = employees
            .filter(function (data) {
              return data.id == responsedata[index].employeeid;
            })
            .map(function (data) {
              return data.projectdesignation;
            });
          responsedata[index]["profilepicture"] = employees
            .filter(function (data) {
              return data.id == responsedata[index].employeeid;
            })
            .map(function (data) {
              return data.profilepicture;
            });
        }

        setslots(responsedata);
      })
      .catch((err) => {
        alert(err);
      });
  };

  const deleteslot = async (item, index) => {
    setslotdeletionindex(index);
    setslotdeletionloader(true);
    await deleteDocument("slots", item.schedulecreationdate)
      .then(async (response) => {
        if (response) {
          let data = [...slots];
          data = data.filter((_, indexdata) => indexdata !== index);
          setslots(data);
          toast.success("Slot Deleted Successfully!");
          setslotdeletionloader(false);
        } else {
          toast.error(
            "Your slot can not be deleted at the moment. Please try again later!",
          );
        }
      })
      .catch((err) => {
        setslotdeletionloader(false);
        toast.error(
          "Your slot can not be deleted at the moment. Please try again later!",
        );
        alert(err);
      });
  };

  const newslotcreatedsuccess = async (employeeid, timeslot) => {
    try {
      const res = await fetch(
        "https://us-central1-raftekpro-82bb0.cloudfunctions.net/api/newslot",
        {
          //  const res = await fetch('http://localhost:3002/dailyreportrequest', {

          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: employeeid,
            timeslot: timeslot,
          }),
        },
      );
      if (res.status == 200) {
        console.log("Notififcation " + JSON.stringify(res));
        const data = await res.json();
        console.log(data);
        console.log("Successfully Notified User");
      } else {
        console.log(res);
        console.log("Notififcation Error" + JSON.stringify(res));
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const convertToTimestamp = (date, timeString) => {
    // Split the time string into hours and minutes
    const [hours, minutes] = timeString.split(":").map(Number);

    // Create a new Date object for the current day
    const now = new Date(date);

    // Set the hours and minutes based on the time string
    now.setHours(hours, minutes, 0, 0); // Set hours, minutes, seconds, milliseconds to 0

    // Return the Unix timestamp (milliseconds since January 1, 1970)
    return now.getTime();
  };

  function isTimeRangeValid(newStart, newEnd, existingRanges) {
    for (const key in existingRanges) {
      if (
        isTimeRangeColliding(
          newStart,
          newEnd,
          existingRanges[key].starttimetimestamp,
          existingRanges[key].endtimetimestamp,
        )
      ) {
        return false;
      }
    }
    return true;
  }

  function isTimeRangeColliding(start1, end1, start2, end2) {
    return start1 < end2 && end1 > start2;
  }

  const handleTaskDragEnd = (dayIndex, event) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    setcleanertasks((prev) => {
      const day = prev[dayIndex];

      const oldIndex = day.tasksdata.findIndex((t) => t.id === active.id);
      const newIndex = day.tasksdata.findIndex((t) => t.id === over.id);

      const updatedTasks = arrayMove(day.tasksdata, oldIndex, newIndex);

      return prev.map((item, index) =>
        index === dayIndex ? { ...item, tasksdata: updatedTasks } : item,
      );
    });
  };

  const createexpressrequest = async () => {
    if (dropoffdestinations.length == 0) {
      toast.warn("Please select atleast 1 drop off destination!");
    } else if (selectedprojects.length == 0) {
      toast.warn("Please select atleast 1 pick up destination!");
    } else if (
      selectedprojects.length > 0 &&
      selectedprojects.some((project) =>
        project.tasks.some((task) => task.notetorider == ""),
      )
    ) {
      toast.warn("Please enter task note!");
    } else if (
      selectedprojects.length > 0 &&
      selectedprojects.some((project) =>
        project.tasks.some((task) => task.dropoffdestination == ""),
      )
    ) {
      toast.warn("Please enter task destination!");
    } else {
      setloading(true);

      slotcreation();
    }
  };

  const groupTasksByDestination = (tasks) => {
    const map = {};

    tasks.forEach((task) => {
      const { dropoffdestination, notetorider, selected } = task;
      let newdropoffdestination = { ...dropoffdestination };

      newdropoffdestination.deliverydate = moment(
        newdropoffdestination.deliverydate,
      ).format("DD-MM-YYYY");

      // Create a unique key for destination
      const key = `${newdropoffdestination.lat},${newdropoffdestination.lng}`;

      if (!map[key]) {
        map[key] = {
          selected,
          dropoffdestination: newdropoffdestination,
          notetorider: [
            {
              task: notetorider,
            },
          ],
        };
      } else {
        alert("no sss");
        map[key].notetorider.push({
          task: notetorider,
        });
      }
    });

    return Object.values(map);
  };

  async function slotcreation() {
    let dataselectedprojects = JSON.parse(JSON.stringify(selectedprojects));
    let datadropoffdestinations = JSON.parse(
      JSON.stringify(dropoffdestinations),
    );
    const formatteddates = [
      ...new Set([
        ...Object.values(dataselectedprojects).map((p) =>
          moment(p.pickupdate).format("YYYY-MM-DD"),
        ),
        ...Object.values(datadropoffdestinations).map((d) =>
          moment(d.deliverydate).format("YYYY-MM-DD"),
        ),
      ]),
    ];

    const projectids = dataselectedprojects[0].projectid;

    const smallestDate = formatteddates.sort()[0];

    let projectsdata = [...dataselectedprojects];
    for (const key in projectsdata) {
      projectsdata[key].pickupdate = moment(
        projectsdata[key].pickupdate,
      ).format("DD-MM-YYYY");

      projectsdata[key].tasks = groupTasksByDestination(
        projectsdata[key].tasks,
      );
    }

    let dropoffdata = [...datadropoffdestinations];
    for (const key in dropoffdata) {
      dropoffdata[key].deliverydate = moment(
        dropoffdata[key].deliverydate,
      ).format("DD-MM-YYYY");
    }

    let employeeshiftinformation = [];
    let slotid = Date.now();

    let updatestasksdata = [];

    let data = {
      //   employeeid: employeeids[keyindex],
      //   assignedvehicle: shifttype == "Driver" ? selectedvehicle?.id : null,
      //   projectdesignation: designation,
      //   timeslot: starttime + " - " + endtime,
      //   starttime: starttime,
      //   starttimetimestamp: convertToTimestamp(dateid, starttime),

      //   lunchallowed: lunchenabled,
      //   lunchstarttime: lunchstarttime,
      //   lunchstarttimestamp: convertToTimestamp(
      //     formattedlunchstartdates[key],
      //     lunchstarttime,
      //   ),
      //   lunchendtime: lunchendtime,
      //   lunchendtimestamp: convertToTimestamp(
      //     formattedlunchenddates[key],
      //     lunchendtime,
      //   ),
      //   endtime: endtime,
      //   endtimetimestamp: convertToTimestamp(
      //     !startendtimeonsameday ? formattedendingdates[key] : dateid,
      //     endtime,
      //   ),
      //   projectlocation: projectdata.location,
      //   priceperhour:
      //     selectedemployee[keyindex]?.projectassigned?.find(
      //       (data) => data.project == projectid,
      //     )?.hourlywage != undefined
      //       ? parseFloat(
      //           selectedemployee[keyindex]?.projectassigned?.find(
      //             (data) => data.project == projectid,
      //           )?.hourlywage,
      //         )
      //       : 0,

      schedulecreationdate: Date.now(),
      sheduleddate: smallestDate,
      slotid: slotid,
      status: "Pending Approval",
      expressdelivery: true,
      supervisornotifiedofimagedeletion: false,
      hoursapproved: "noaction",
      cleaningshiftid: null,
      pickupdestinations: projectsdata,
      dropoffdestinations: dropoffdata,
      shifttype: shifttype,
      createdby: user.id,
      minutes: 0,
      late: false,
      projectid: projectids,
      expressshiftapproved: false,
    };

    await saveitemwithid("slots", data.schedulecreationdate.toString(), data)
      .then(async (response) => {
        emailclient();
        notifysupervisor(
          projectids,
          user.firstname + " " + user.lastname,
          projectsdata[0].pickupdate,
          projectsdata[0].pickuptime,
          data.schedulecreationdate.toString(),
        );
        toast.success(`Express Delivery requested Successfully!`);

        setselectedemployee("");
        setdesignation("");
        setstartdate(new Date());
        setenddate(new Date());
        setselectedvehicle("");
        setendingdate(new Date());
        setlunchstartdate(new Date());
        setlunchenddate(new Date());
        setlunchstarttime("13:00");
        setlunchendtime("14:00");
        setstarttime("10:00");
        setendtime("19:00");
        setloading(false);
      })
      .catch((err) => {
        console.log(err);
        setloading(false);
        toast.error(
          "Something went wrong while posting your Schedule. Please try again later.",
        );
      });
  }

  const notifysupervisor = async (
    projectid,
    clientname,
    pickupdate,
    pickuptime,
    shiftid,
  ) => {
    try {
      const res = await fetch(
        "https://us-central1-raftekpro-82bb0.cloudfunctions.net/api/expressrequest",
        {
          // const res = await fetch('http://localhost:3002/expressrequest', {

          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            projectid: projectid,
            clientname: clientname,
            pickupdate: pickupdate,
            pickuptime: pickuptime,
            shiftid: shiftid,
          }),
        },
      );
    } catch (error) {
      toast.error("Error processing notification");
    }
  };
  const emailclient = async (e) => {
    try {
      const templateParams = {
        email: user.email,
        title: selectedprojects[0]?.projectdata.title,
        info: `A Fixed Price of $ ${selectedprojects[0]?.projectdata?.expressdeliveryfixed} will be charged for the first ${selectedprojects[0]?.projectdata?.expressdeliveryfixedhours} hours of delivery duration. Any delivery exceeding the maximum
                    hours will be charged an additional hourly rate of $ ${selectedprojects[0]?.projectdata?.expressdeliveryhourly} / hr.`,
      };

      await emailjs
        .send(
          "service_5z77uee", // Replace with your Service ID
          "template_ub365qk", // Replace with your Template ID
          templateParams,
          "pUoX1kN2nzw7N8UsM", // Replace with your User ID
        )
        .then((response) => {
          console.log("SUCCESS!", response.status, response.text);
        })
        .catch((err) => {
          console.error("FAILED...", err);
        });
    } catch (error) {
      toast.error("Error processing request");
    }
  };
  const getallprojectdesignations = async () => {
    await getuserinformation("users", projectid)
      .then(async (response) => {
        if (response.designation != undefined) {
          setdesignationoptions(response.designation);
          getvehiclesdata(response.vehiclesassigned || []);
        }

        if (response.cleaningtasks != undefined) {
          let newdata = [...response.cleaningtasks];
          for (const key in newdata) {
            if (newdata[key].numberoftasks == undefined) {
              newdata[key]["numberoftasks"] = newdata[key].tasksdata.length;

              for (const innerkey in newdata[key].tasksdata) {
                newdata[key].tasksdata[innerkey]["id"] = innerkey;
              }
            }
          }
          setcleanertasksstorage(newdata);

          setcleanertasks(newdata);
        }

        setprojectdata(response);
      })
      .catch((err) => {
        alert(err);
      });
  };

  async function getvehiclesdata(data) {
    if (data.length > 0) {
      await getAllVehiclesWhere("vehicles", data)
        .then(async (response) => {
          setvehicles(response);
        })
        .catch((err) => {
          alert(err);
        });
    } else {
      setvehicles([]);
    }
  }

  //////////////new//////
  const handleSelect = async (place) => {
    setLocation(place);
    //   const address = place.label; // Extract the address string

    //   try {
    //     const response = await fromAddress(address);
    //     const { lat, lng } = response.results[0].geometry.location;

    //     //   setCoordinates({ lat, lng });
    //   } catch (error) {
    //     console.error("Error fetching geocode:", error);
    //   }
  };

  const MarqueeText = (text) => {
    return (
      <div className="marquee">
        <div className="marquee__inner">
          <span className="PoppinsRegular text-white text-sm">{text}</span>
          <span className="PoppinsRegular text-white text-sm">{text}</span>
          {/* MUST duplicate */}
        </div>
      </div>
    );
  };

  return (
    <div className="min-h-screen flex flex-col items-center w-full">
      <div
        className={`w-full  px-3 lg:px-7 rounded-xl    bg-themelightblack  drop-shadow-lg lg:mb-[30px] py-[20px] mx-auto  `}
      >
        <div className="flex flex-col  items-center justify-between w-full md:mt-[20px]">
          <div className="flex flex-col justify-between   w-full md:mx-[40px]">
            <div className="w-full px-[10px] py-[10px] rounded-xl bg-themeblue   mb-[30px] ">
              <p className="PoppinsRegular text-white text-xl w-full text-center ">
                Express Delivery
              </p>
            </div>
          </div>
        </div>

        {selectedprojects.length == 0 && (
          <>
            <p className="PoppinsRegular text-white text-lg   mt-[30px] ">
              Drop Off Destinations
            </p>
            <div className="w-[100%] PoppinsRegular mt-[20px]">
              <GooglePlacesAutocomplete
                apiKey={apikey}
                selectProps={{
                  Location,
                  onChange: (item) => {
                    handleSelect(item);
                  },
                  placeholder: "Select your address",
                  value: Location,
                }}
                name="address"
                value={Location}
              />
            </div>
            <button
              disabled={Location != "" ? false : true}
              onClick={async () => {
                //   setLocation(place);
                const address = Location.label; // Extract the address string

                try {
                  setLocation("");
                  const response = await fromAddress(address);
                  const { lat, lng } = response.results[0].geometry.location;
                  let object = {
                    destination: address,
                    lat: lat,
                    lng: lng,
                    deliverydate: new Date(),
                    deliverytime: "10:00",
                    notes: "",
                    phonenumber: "",
                    contactperson: "",
                    destinationid: Date.now(),
                  };

                  let data = [...dropoffdestinations];
                  data.push(object);
                  setdropoffdestinations(data);
                } catch (error) {
                  console.error("Error fetching geocode:", error);
                }
              }}
              type="submit"
              className={`text-center py-2 rounded-lg  ${Location != "" ? "bg-themeblue" : "bg-white/80"} hover:bg-themeblue/80 text-white text-sm  PoppinsRegular uppercase w-[150px] mt-[10px] `}
            >
              Add Destination
            </button>

            <div className="mt-[30px] ">
              {dropoffdestinations.map((item, index) => (
                <div
                  key={index.toString()}
                  className="flex flex-col justify-center items-center mb-[10px] mt-[10px]  bg-themeColor  drop-shadow-lg p-4 rounded-lg relative"
                >
                  <div className=" flex flex-row items-center justify-between w-full">
                    <p className="PoppinsRegular text-white text-md   text-start  uppercase w-[80%]">
                      {item.destination}
                    </p>
                    <button
                      onClick={() => {
                        let data = [...dropoffdestinations];
                        data.splice(index, 1);
                        setdropoffdestinations(data);
                      }}
                      type="submit"
                      className="text-center py-2 rounded-lg  bg-themeblue hover:bg-red-500   text-white text-sm  PoppinsRegular uppercase w-[100px]  "
                    >
                      REMOVE
                    </button>
                  </div>
                  <div className="flex flex-col  items-center justify-center w-full  mt-[20px]">
                    <div className="flex flex-col    w-full ">
                      <p className="PoppinsRegular text-white/80 text-sm  pb-1">
                        Drop Off Date/Time
                      </p>
                      <div className="w-full flex justify-between items-center">
                        <DatePicker
                          minDate={new Date()}
                          className="input PoppinsRegular  border border-bordercolor rounded-lg w-full bg-themelightblack text-white "
                          selected={item.deliverydate}
                          onChange={(date) => {
                            let selecteddropoffdata = [...dropoffdestinations];
                            selecteddropoffdata[index].deliverydate = date;
                            setdropoffdestinations(selecteddropoffdata);
                          }}
                        />

                        <TimePicker
                          format="HH:mm"
                          className="  ml-[10px]  w-full h-[45px] bg-themelightblack text-white "
                          onChange={(time) => {
                            let selecteddropoffdata = [...dropoffdestinations];
                            selecteddropoffdata[index].deliverytime = time;
                            setdropoffdestinations(selecteddropoffdata);
                          }}
                          value={item.deliverytime}
                        />
                      </div>
                      <div className="w-full flex flex-row justify-between mt-[20px]">
                        <div className="w-[49%]">
                          <p className="PoppinsRegular text-textcolor text-sm  pb-1">
                            Receiver Name
                          </p>
                          <input
                            type="text"
                            value={item.contactperson}
                            placeholder="Receiver Name"
                            onChange={(event) => {
                              let pickupdata = [...dropoffdestinations];
                              pickupdata[index].contactperson =
                                event.target.value;
                              setdropoffdestinations(pickupdata);
                            }}
                            className="input px-4 text-textcolor text-sm  PoppinsRegular w-full py-2 rounded-xl border border-bordercolor items-center flex bg-themelightblack"
                          />
                        </div>

                        <div className="w-[49%]">
                          <p className="PoppinsRegular text-textcolor text-sm  pb-1">
                            Phone Number
                          </p>
                          <input
                            type="text"
                            value={item.phonenumber}
                            placeholder="Phone Number"
                            onChange={(event) => {
                              let pickupdata = [...dropoffdestinations];
                              pickupdata[index].phonenumber =
                                event.target.value;
                              setdropoffdestinations(pickupdata);
                            }}
                            className="input px-4 text-textcolor text-sm  PoppinsRegular w-full py-2 rounded-xl border border-bordercolor items-center flex bg-themelightblack"
                          />
                        </div>
                      </div>

                      <div className="w-full mt-5">
                        <p className="PoppinsRegular text-textcolor text-sm  pb-1">
                          Droff Off Notes
                        </p>
                        <textarea
                          type="text"
                          placeholder="Additional Notes..."
                          onChange={(event) => {
                            let pickupdata = [...dropoffdestinations];
                            pickupdata[index].notes = event.target.value;
                            setdropoffdestinations(pickupdata);
                          }}
                          value={item.notes}
                          className="input px-4 text-textcolor text-sm  PoppinsRegular w-full py-2 rounded-xl border border-bordercolor items-center flex h-[200px] bg-themelightblack"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
        <p className="PoppinsRegular text-white text-lg  mt-[40px] ">
          Pick Up Destinations
        </p>
        <div className="w-full lg:w-[49%] mt-[10px] relative ">
          <div className="flex flex-row items-end justify-between pb-1 ">
            <p className="PoppinsRegular  text-white/80 text-sm ">
              Select Project
            </p>
          </div>
          <div
            onClick={() => setprojectselectionpopup(!projectselectionpopup)}
            className="px-4 text-white text-sm  PoppinsRegular w-full py-[10px] rounded-lg border border-bordercolor   bg-themelightblack items-center flex"
          >
            {selectedprojects[0]?.projectdata.title == undefined
              ? "Select Project"
              : selectedprojects[0]?.projectdata.title}
          </div>

          <ProjectPopUp
            style={{ top: "80px", left: "0px" }}
            visible={projectselectionpopup}
            data={clients}
            activateoutsidecontainerclick={() => {
              setprojectselectionpopup(false);
            }}
            onClickcorrect={(item) => {
              let data = { ...item };
              let selectedprojectdata = [];
              selectedprojectdata.push({
                projectid: item.id,
                projectdata: item,
                notes: "",
                phonenumber: "",
                contactperson: "",
                pickupaddress: "",
                pickupdate: new Date(),
                pickuptime: "10:00",
                tasks: [
                  {
                    notetorider: "",
                    dropoffdestination: "",
                  },
                ],
              });

              setselectedprojects(selectedprojectdata);

              setprojectselectionpopup(false);
            }}
          />
        </div>

        <div className="mt-[30px]">
          {selectedprojects.map((item, index) => (
            <div
              key={index.toString()}
              className="flex flex-col justify-center items-center mb-[10px] mt-[40px]  bg-themeColor  drop-shadow-lg p-6 rounded-lg relative"
            >
              <div className="mt-5">
                <button
                  onClick={() => {
                    let data = [...selectedprojects];
                    data.splice(index, 1);
                    setselectedprojects(data);
                  }}
                  type="submit"
                  className="text-center py-2 rounded-lg  bg-themeblue hover:bg-red-500   text-white text-sm  PoppinsRegular uppercase w-[100px]  position absolute right-[20px] top-[20px]"
                >
                  REMOVE
                </button>

                <div className="position absolute left-[20px] top-[20px] bg-themelightblack  p-4 rounded-xl">
                  <div className="flex flex-row">
                    <p className="PoppinsRegular text-white/80 text-sm ">
                      Fixed Price:
                    </p>
                    <p className="PoppinsRegular  text-sm ml-[5px] text-themegreen ">
                      $ {item.projectdata.expressdeliveryfixed}
                    </p>
                    <p className="PoppinsRegular text-white/80 text-sm ml-[5px] ">
                      -
                    </p>
                    <p className="PoppinsRegular  text-sm ml-[5px]   text-red-500">
                      {item.projectdata.expressdeliveryfixedhours} hours (max)
                    </p>
                  </div>

                  <div className="flex flex-row">
                    <p className="PoppinsRegular text-white/80 text-sm ">
                      Hourly Price:
                    </p>
                    <p className="PoppinsRegular  text-sm ml-[5px]  text-themegreen">
                      $ {item.projectdata.expressdeliveryhourly + " / hr"}
                    </p>
                  </div>
                </div>
              </div>

              <img
                loading="lazy"
                src={item.projectdata.logo}
                className="w-[160px] h-[160px] object-cover rounded-full"
              />

              <div className="flex justify-center items-center bg-themeblue p-2 w-full mt-[20px] rounded-lg">
                <p className="text-white">{`A Fixed Price of $ ${item.projectdata.expressdeliveryfixed} will be charged for the first ${item.projectdata.expressdeliveryfixedhours} hours of delivery duration. Any delivery exceeding the maximum
                    hours will be charged an additional hourly rate of $ ${item.projectdata.expressdeliveryhourly} / hr.          `}</p>
              </div>

              <div className="flex flex-col  items-center justify-center w-full  mt-[20px]">
                <div className="flex flex-col    w-full ">
                  <p className="PoppinsRegular text-white/80 text-sm  pb-1">
                    Pick Up Date/Time
                  </p>
                  <div className="w-full flex justify-between items-center">
                    <DatePicker
                      minDate={new Date()}
                      className="input PoppinsRegular  border border-bordercolor rounded-lg w-full bg-themelightblack text-white"
                      selected={item.pickupdate}
                      onChange={(date) => {
                        let selectedprojectdata = [...selectedprojects];
                        selectedprojectdata[index].pickupdate = date;
                        setselectedprojects(selectedprojectdata);
                      }}
                    />

                    <TimePicker
                      format="HH:mm"
                      className="  ml-[10px]  w-full h-[45px] bg-themelightblack text-white"
                      onChange={(time) => {
                        let selectedprojectdata = [...selectedprojects];
                        selectedprojectdata[index].pickuptime = time;
                        setselectedprojects(selectedprojectdata);
                      }}
                      value={item.pickuptime}
                    />
                  </div>
                </div>
              </div>
              <div className="w-[100%] PoppinsRegular mt-[20px]">
                <GooglePlacesAutocomplete
                  apiKey={apikey}
                  selectProps={{
                    onChange: (place) => {
                      let pickupdata = [...selectedprojects];
                      pickupdata[index].pickupaddress = place;
                      setselectedprojects(pickupdata);
                    },
                    placeholder: "Select your address",
                    defaultValue: item.pickupaddress,
                  }}
                  name="address"
                  value={item.pickupaddress}
                />
              </div>

              <div className="w-full flex flex-row justify-between mt-[20px]">
                <div className="w-[49%]">
                  <p className="PoppinsRegular text-textcolor text-sm  pb-1">
                    Contact Person
                  </p>
                  <input
                    type="text"
                    value={item.contactperson}
                    placeholder="Contact Person"
                    onChange={(event) => {
                      let pickupdata = [...selectedprojects];
                      pickupdata[index].contactperson = event.target.value;
                      setselectedprojects(pickupdata);
                    }}
                    className="input px-4 text-textcolor text-sm  PoppinsRegular w-full py-2 rounded-xl border border-bordercolor items-center flex bg-themelightblack"
                  />
                </div>

                <div className="w-[49%]">
                  <p className="PoppinsRegular text-textcolor text-sm  pb-1">
                    Phone Number
                  </p>
                  <input
                    type="text"
                    value={item.phonenumber}
                    placeholder="Phone Number"
                    onChange={(event) => {
                      let pickupdata = [...selectedprojects];
                      pickupdata[index].phonenumber = event.target.value;
                      setselectedprojects(pickupdata);
                    }}
                    className="input px-4 text-textcolor text-sm  PoppinsRegular w-full py-2 rounded-xl border border-bordercolor items-center flex bg-themelightblack"
                  />
                </div>
              </div>

              <div className="w-full mt-5">
                <p className="PoppinsRegular text-textcolor text-sm  pb-1">
                  Pick Up Notes
                </p>
                <textarea
                  type="text"
                  placeholder="Additional Notes..."
                  onChange={(event) => {
                    let pickupdata = [...selectedprojects];
                    pickupdata[index].notes = event.target.value;
                    setselectedprojects(pickupdata);
                  }}
                  value={item.notes}
                  className="input px-4 text-textcolor text-sm  PoppinsRegular w-full py-2 rounded-xl border border-bordercolor items-center flex h-[200px] bg-themelightblack"
                />
              </div>
              <p className="PoppinsRegular text-white text-md  pb-1 w-full text-start mt-[30px]">
                {item.projectdata.title + " - Tasks"}
              </p>
              {item.tasks.map((inneritem, innerindex) => (
                <div className="ml-[10px] w-full">
                  <div className="mt-5 flex flex-row items-center justify-start">
                    <div className="flex flex-row justify-center items-center  ">
                      <FaCircleMinus
                        onClick={() => {
                          let data = [...selectedprojects];
                          data[index].tasks.splice(innerindex, 1);
                          setselectedprojects(data);
                        }}
                        className=" text-red-500 w-[20px] h-[20px] hover:cursor-pointer"
                      />
                    </div>
                    <input
                      type="text"
                      placeholder="Enter task..."
                      value={inneritem.notetorider}
                      onChange={(event) => {
                        handledesignationChange(event, index, innerindex);
                      }}
                      className={`input relative px-4 ${
                        item.tasks == "" ? " text-lighttextGray " : "text-white"
                      } text-sm  PoppinsRegular w-full h-[45px] rounded-xl border border-bordercolor items-center flex bg-themelightblack text-white ml-[10px]`}
                    />
                    <div className="w-[35%] relative ">
                      <div
                        onClick={() => {
                          let data = [...selectedprojects];
                          data[index].tasks[innerindex]["selected"] =
                            !data[index].tasks[innerindex]["selected"];
                          setselectedprojects(data);
                        }}
                        className="ml-[10px] px-4 text-white text-sm  PoppinsRegular w-full h-[45px] rounded-xl border border-bordercolor   bg-themelightblack items-center flex justify-center hover:cursor-pointer "
                      >
                        <p className="line-clamp-2">
                          {inneritem.dropoffdestination == ""
                            ? "Destination"
                            : inneritem?.dropoffdestination?.destination}
                        </p>
                      </div>

                      <ProjectPopUp
                        style={{ top: "50px", left: "-20px" }}
                        visible={inneritem.selected}
                        data={dropoffdestinations}
                        type={"address"}
                        activateoutsidecontainerclick={() => {
                          let data = [...selectedprojects];
                          data[index].tasks[innerindex]["selected"] = false;
                          setselectedprojects(data);
                        }}
                        onClickcorrect={(item) => {
                          let data = { ...item };
                          let selectedprojectdata = [...selectedprojects];
                          selectedprojectdata[index].tasks[
                            innerindex
                          ].dropoffdestination = data;
                          selectedprojectdata[index].tasks[innerindex][
                            "selected"
                          ] = false;
                          setselectedprojects(selectedprojectdata);
                        }}
                      />
                    </div>
                  </div>
                </div>
              ))}
              <div
                onClick={() => {
                  let object = {
                    notetorider: "",
                    dropoffdestination: "",
                  };

                  let data = [...selectedprojects];
                  data[index].tasks.push(object);
                  setselectedprojects(data);
                }}
                className="w-full flex justify-center my-[20px] flex-col items-center hover:cursor-pointer text-lighttextGray/80 hover:text-themegreen"
              >
                <CiCirclePlus className=" w-[40px] h-[40px] " />
                <p className=" PoppinsRegular ">Add Tasks</p>
              </div>
            </div>
          ))}
        </div>

        <p className="PoppinsRegular text-white text-lg  mt-[40px] ">
          Overview
        </p>
        <div className="w-full flex flex-row overflow-x-scroll mt-[20px]">
          {selectedprojects.map((item, index) => (
            <div className="flex flex-row items-center justify-center">
              <div
                key={index.toString()}
                className="flex flex-col justify-center items-center mb-[10px]   bg-themeColor  drop-shadow-lg p-6 rounded-lg relative mr-[10px] min-w-[240px] max-w-[240px]"
              >
                <img
                  loading="lazy"
                  src={item.projectdata.logo}
                  className="w-[160px] h-[160px] object-cover rounded-full"
                />
                <div className="flex items-start flex-col mt-[20px]">
                  <div className="flex items-start justify-center flex-row">
                    <p className="PoppinsRegular text-white/80 text-sm      text-start ">
                      Pick Up Date:
                    </p>
                    <p className="PoppinsRegular text-white text-sm     text-start ml-[10px] ">
                      {moment(item.pickupdate).format("DD-MM-YYYY")}
                    </p>
                  </div>
                  <div className="flex items-start justify-center flex-row">
                    <p className="PoppinsRegular text-white/80 text-sm  text-start  ">
                      Pick Up Time:
                    </p>
                    <p className="PoppinsRegular text-white text-sm      text-start ml-[10px] ">
                      {item.pickuptime}
                    </p>
                  </div>
                </div>
              </div>
              <div className="mr-[20px]">
                <FaArrowRight className="  text-white w-[40px] h-[40px] " />
              </div>
            </div>
          ))}
          {dropoffdestinations.map((item, index) => (
            <div className="flex flex-row items-center justify-center">
              <div
                key={index.toString()}
                className="flex flex-col justify-center items-center mb-[10px]   bg-themeColor  drop-shadow-lg p-6 rounded-lg relative mr-[10px] min-w-[240px] max-w-[240px]"
              >
                <div className="flex h-[160px] justify-center items-center">
                  <p className="PoppinsRegular text-white text-md   text-center  uppercase  w-full">
                    {item.destination}
                  </p>
                </div>
                <div className="flex items-start flex-col mt-[20px]">
                  <div className="flex items-start justify-center flex-row">
                    <p className="PoppinsRegular text-white/80 text-sm      text-start ">
                      Drop Off Date:
                    </p>
                    <p className="PoppinsRegular text-white text-sm     text-start ml-[10px] ">
                      {moment(item.deliverydate).format("DD-MM-YYYY")}
                    </p>
                  </div>
                  <div className="flex items-start justify-center flex-row">
                    <p className="PoppinsRegular text-white/80 text-sm  text-start  ">
                      Drop Off Time:
                    </p>
                    <p className="PoppinsRegular text-white text-sm      text-start ml-[10px] ">
                      {item.deliverytime}
                    </p>
                  </div>
                </div>
              </div>
              {index < dropoffdestinations.length - 1 && (
                <div className="mr-[20px]">
                  <FaArrowRight className="  text-white w-[40px] h-[40px] " />
                </div>
              )}
            </div>
          ))}
        </div>
        <div className="w-full flex items-center justify-center mt-[30px] ">
          {loading ? (
            <div className=" py-4  mt-6 w-full flex justify-center   ">
              <RotatingLines
                visible={true}
                height="25"
                width="25"
                color="grey"
                strokeColor="#00C763"
                strokeWidth="5"
                animationDuration="0.75"
                ariaLabel="rotating-lines-loading"
                wrapperStyle={{}}
                wrapperClass=""
              />
            </div>
          ) : (
            <button
              onClick={() => {
                createexpressrequest();
              }}
              type="submit"
              className="text-center py-4 rounded-2xl  bg-themeblue hover:bg-themeblue/80 w-full  text-white text-sm  PoppinsRegular uppercase "
            >
              Request Express Delivery
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default CreateExpressDelivery;
